import React, { useState } from "react";
import { BellRing, X } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { enablePush, pushSupported, playDing } from "@/lib/push";

const KEY = "gs_push_prompt_closed";

export function PushPrompt() {
  const { user } = useAuth();
  const [hidden, setHidden] = useState(() => localStorage.getItem(KEY) === "1");
  const [busy, setBusy] = useState(false);
  if (!user || hidden || !pushSupported() || Notification.permission !== "default") return null;

  const close = () => { localStorage.setItem(KEY, "1"); setHidden(true); };
  const turnOn = async () => {
    setBusy(true);
    playDing();
    await enablePush(true).catch(() => {});
    setBusy(false);
    setHidden(true);
  };

  return (
    <div data-testid="push-prompt" className="fixed left-3 right-3 bottom-24 z-40 max-w-md mx-auto bg-white rounded-2xl shadow-lg border border-slate-100 p-3 flex items-center gap-3">
      <span className="w-10 h-10 rounded-full bg-emerald-50 text-emerald-600 flex items-center justify-center shrink-0"><BellRing className="w-5 h-5" /></span>
      <div className="flex-1 min-w-0">
        <p className="text-sm font-bold text-slate-900">Merr sinjal për çdo SMS</p>
        <p className="text-xs text-slate-500">Edhe kur telefoni është i mbyllur</p>
      </div>
      <button data-testid="push-prompt-enable" disabled={busy} onClick={turnOn} className="bg-emerald-600 text-white text-sm font-semibold rounded-full px-4 py-2 active:scale-95 transition-transform">Aktivizo</button>
      <button data-testid="push-prompt-close" onClick={close} aria-label="Mbyll" className="text-slate-400"><X className="w-4 h-4" /></button>
    </div>
  );
}
